//------------- DATAGRID ROTAS COMPONENT ---------

//datagrid da página de rotas
//fica ao lado do formulário

//importações
import React from "react";
import { useState, useEffect } from "react";
import "./styles.css";

import toast, { Toaster } from "react-hot-toast";

import InputSearch from "../inpt-search";

import Requests from "../../services/requests";

//icons
import { BiRefresh } from "react-icons/bi";
import { FaTrashAlt } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { FiChevronRight } from "react-icons/fi";
import { FiChevronLeft } from "react-icons/fi";
import { BsCheck } from "react-icons/bs";
import { BsX } from "react-icons/bs";

//component
//setselecteditem envia a rota para o formulário da página Rotas
const DatagridRotas = ({ token, id_usuario, setSelectedItem, observaRota, setObservaRota }) => {
	const [delItem, setdelItem] = useState({}); //item selecionado para exclusão
	const [loading, setLoading] = useState(false); //animação de loading

	const [search, setSearch] = useState(""); //barra de pesquisa
	const [page, setPage] = useState(0); //pagina atual do grid
	const [rotas, setRotas] = useState([]); //conjunto de rotas mutável
	const [rotasAll, setRotasAll] = useState([]); //conjunto de todas as rotas
	const [rotasPage, setRotasPage] = useState([]); //rotas da página atual
	const limit = 4; //limite de rotas por pagina

	//botão bolinha estilizado
	const StyledBtn = ({ icon, stl, text, event }) => {
		const [onhover, setonhover] = useState(false);
		return (
			<div
				onClick={event ? event : () => {}}
				onMouseOver={() => {
					setonhover(true);
				}}
				onMouseOut={() => {
					setonhover(false);
				}}
				className={stl}
			>
				{onhover ? text : icon}
			</div>
		);
	};

	//carrega as rotas do banco
	const loadContent = () => {
		let parametros = { id_usuario };
		let config = { headers: { "x-access-token": token } };
		Requests.getRotas(config)
			.then((res) => {
				if (res) {
					let content = res.sort((a, b) => {
						return a.nome.localeCompare(b.nome);
					});
					//lógica que gerencia as páginas do dgrid
					let startContent = [];
					for (let i = limit * page; i < limit * page + limit; i++) {
						if (res[i]) {
							startContent.push(res[i]);
						}
					}
					//setta os states com o resultado da request
					setRotas(content);
					setRotasAll(content);
					setRotasPage(startContent);
					setPage(0);
				}
			})
			.catch((res, err) => {
				console.log(res, err);
			});
	};

	//verifica se o botão avançar e voltar página estão habilitados
	//conforme a página atual e as páginas seguintes
	const handlePageAble = (button) => {
		switch (button) {
			case "left":
				if (page === 0) {
					return false;
				} else {
					return true;
				}
			case "right":
				if (page < rotas.length / limit - 1) {
					return true;
				} else {
					return false;
				}

			default:
				break;
		}
	};

	//gerencia a barra de pesquisa
	const handleSearch = () => {
		let filtered;
		filtered = rotasAll.filter((a) => {
			return a.nome.toLowerCase().includes(search.toLocaleLowerCase());
		});
		setRotas(filtered);
		handleChangePage(filtered);
	};

	//gerencia a troca de página
	const handleChangePage = (r = rotas) => {
		let actualRotas = [];
		for (let i = limit * page; i < limit * page + limit; i++) {
			if (r[i]) {
				actualRotas.push(r[i]);
			}
		}
		setRotasPage(actualRotas);
	};

	//deleta uma rota
	const handleDelete = (item) => {
		//função que efetivamente envia a request de delet
		const delItem = (id) => {
			//deleta o item no banco
			let config = { headers: { "x-access-token": token } };
			let object = {
				id: id,
			};
			Requests.deleteRotas(object, config)
				.then((res) => {
					if (res.affectedRows > 0) {
						setdelItem({});
						loadContent();
						setLoading(true);
						setTimeout(() => {
							toast.success("Rota excluida com sucesso!");
							setObservaRota(!observaRota);
							setLoading(false);
						}, 1500);
					} else {
						toast.error("Não foi possível excluir a rota");
					}
				})
				.catch((err) => {
					toast.error("Não foi possível excluir a rota");
					console.log(err);
				});
		};

		//abre o popup de confirmação de exclusão
		if (item.id) {
			return (
				<div className="popup-wrapper">
					<p>{"DELETAR ROTA?"}</p>
					<p>
						{"A rota "}
						<b>{item.nome}</b>
						{" está prestes a ser excluida, deseja realmente prosseguir?"}
					</p>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<StyledBtn
							event={() => {
								setdelItem({});
							}}
							text={"cancelar"}
							icon={<BsX />}
							stl="btn-nok"
						></StyledBtn>
						<StyledBtn
							event={() => {
								delItem(item.id);
							}}
							text={"excluir"}
							icon={<BsCheck />}
							stl="btn-ok"
						></StyledBtn>
					</div>
				</div>
			);
		}
	};

	//carrega o conteudo
	useEffect(() => {
		loadContent();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//watcher da barra de pesquisa, para não bugar o loadcontent da página
	useEffect(() => {
		if (search) {
			handleChangePage(rotas);
		} else {
			handleChangePage();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page]);

	//view
	return (
		<div className="datagrid-rotas-body">
			<label>Visualizar todas as rotas</label>
			<Toaster />
			{/* popup */}
			{handleDelete(delItem)}
			{/* datagrid */}
			<div className="datagrid-rotas-container">
				{/* barra de pesquisa */}
				<InputSearch
					handleSearch={handleSearch}
					search={search}
					setSearch={setSearch}
					size="full"
					placeholder="Rotas..."
				></InputSearch>
				{/* verifica se está carregando e retorna os itens de cada rota */}
				{!loading ? (
					<div id="dg-list">
						{rotasPage.map((element, i) => {
							return (
								<div className="datagrid-rotas-item" key={"rota-" + i}>
									<p>{element.nome}</p>
									<div className="buttons">
										<StyledBtn
											event={() => {
												setSelectedItem(element);
											}}
											text={"editar"}
											icon={<FaRegEdit />}
											stl="btn-edit"
										></StyledBtn>
										<StyledBtn
											event={() => setdelItem(element)}
											text={"deletar"}
											icon={<FaTrashAlt />}
											stl="btn-delet"
										></StyledBtn>
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<div id="dg-list" className="refresh-page">
						<BiRefresh />
					</div>
				)}
				{/* rodapé onde estão os botões de passar página */}
				<div className="datagrid-rotas-footer">
					<div
						onClick={async () => {
							setSelectedItem({});
							loadContent();
							setLoading(true);
							setTimeout(() => {
								setLoading(false);
							}, 1500);
						}}
					>
						<StyledBtn
							text={"recarregar"}
							icon={<BiRefresh />}
							stl="btn-refresh"
						></StyledBtn>
					</div>
					{/* demonstra quais itens estão no dgrid */}
					<p>{limit * page + 1 + "-" + (limit * page + limit) + " de " + rotas.length}</p>
					{handlePageAble("left") ? (
						<FiChevronLeft
							className="enable"
							onClick={() => {
								setLoading(true);
								setTimeout(() => {
									setPage(page - 1);
									setLoading(false);
								}, 200);
							}}
						/>
					) : (
						<FiChevronLeft />
					)}
					{handlePageAble("right") ? (
						<FiChevronRight
							className="enable"
							onClick={() => {
								setLoading(true);
								setTimeout(() => {
									setPage(page + 1);
									setLoading(false);
								}, 200);
							}}
						/>
					) : (
						<FiChevronRight />
					)}
				</div>
			</div>
		</div>
	);
};

export default DatagridRotas;
